window.Rover = window.Rover || {};

export default window.Rover;



// WEBPACK FOOTER //
// ../globals/Rover.js